<div *ngFor="let item of assignmentData; let i = index"
     class="gs-suggestion-assignment-card-content"
     (click)="onWorkOrderSuggestionClick(item)">
  <div class="gs-suggestion-row">
    <div class="gs-suggestion-wo-info">
      {{item.InternalCompanyCode}} {{item.WorkOrderNumber}}
      <span *ngIf="item.IsT4SalariedPaySideWorkOrder === 1" class="t4-salaried-badge badge badge-primary-custom">Pay Side Work Order</span>
    </div>
    <div class="gs-suggestion-wo-period" *ngIf="item.StartDate || item.EndDate">
      {{item.StartDate | date:dateFormat}} -
      {{item.EndDate | date:dateFormat}} </div>
  </div>
  <br/>
  <div class="gs-suggestion-worker-info">{{item.WorkerDisplayName}}
    ({{getProfileTypeForDisplay(item.ProfileTypeCode, item.T4TypeId) || '-'}})
  </div>
  <br/> 
  <div>
    <div class="gs-suggestion-assignment-clientname"><i class="fa fa-building"></i> {{item.ClientName}}</div>
    <div class="gs-suggestion-wo-period">
      <div class="circle" [ngClass]="{
            'active-status':item.AssignmentStatus === 'Engaged',
            'processing-status':item.AssignmentStatus === 'Onboarding' || item.AssignmentStatus === 'Offboarding',
            'complete-status':item.AssignmentStatus === 'Complete'
        }">
      </div>
      <span class="gs-suggestion-wo-period">
          {{item.AssignmentStatus || '-'}} [{{item.WOStatus || '-'}}]
      </span>
    </div>
  </div>
  <br/>
  <i class="fa fa-search searchicon"></i>
  <div [innerHtml]="item.SearchText" class="searchtext"></div>
</div>
